export const contact = {
	contact: {
		title: "Contact",
		description: "お気軽にお問い合わせください。",
		emailMe: "メールを送る",
		socials: "SNS",
	},
} as const;
